import React from "react";
import {Modal} from "@appkit4/react-components/modal"
import ModalFooter from "@appkit4/react-components/esm/modal/ModalFooter";
import {Button} from "@appkit4/react-components/button"
import PropTypes from "prop-types";

export default function ModalComponent(props) {

    return (
        <div >
            <Modal
                className="baseline-modal-showcase"
                visible={props.visible}
                onCancel={props.cancel}
                bodyStyle={{maxHeight:"280px"}}
                footerStyle={{paddingTop:"8px", marginTop:"-8px"}}
                modalStyle={{width:"49.75rem", maxHeight:"fit-content"}}
            >
                    {props.content ? props.content : "Are you sure you want to delete this entry?"}
                <ModalFooter>
                        <Button
                            className='secondaryButton removeRadius'
                            kind='secondary'
                            onClick={props.cancel}
                        >
                            No
                          </Button>
                        <Button
                         className='removeRadius buttonColor'
                            size='lg'
                            onClick={props.confirm}
                           
                        >
                            Yes
                         </Button>
                </ModalFooter>
            </Modal>
        </div>
    )
};

ModalComponent.propTypes = {
    visible: PropTypes.any,
    cancel: PropTypes.any,
    content: PropTypes.any,
    confirm: PropTypes.any
}
